import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class SpriteTarget extends Phaser.GameObjects.Image {
  /**
     * 
     * @param {Phaser.Scene} scene 
     */
  constructor(scene, sprite, spriteSheet = ABCyaPhaser.Images.DEFAULT_ATLAS) {
    super(scene, 0, 0, spriteSheet, sprite);

    this.enabled = true;
    this.setOrigin(0.5).setInteractive()
      .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick, this);
  }

  doClick() {
    if (!this.enabled) return;

    // make button shrink and expand to react to click
    this.alpha = 1.0;

    this.scene.tweens.timeline({
      tweens:
                [
                  ABCyaPhaser.Tweens.createTween(this, 70, { scale: 0.8 }, Phaser.Math.Easing.Quadratic.Out),
                  ABCyaPhaser.Tweens.createTween(this, 70, { scale: 1 }, Phaser.Math.Easing.Quadratic.Out),
                ]
    });

    if (this.clickAction) {
      this.clickAction(this);
    }
  }
}